import api from './axiosConfig';

// Datos checklist vehiculo dado ID (Id_Checklist)
import { obtenerCklVehiculo } from './conductoresService'; 
// Datos revision vehiculo dado ID (Numero OT)
import { obtenerRevision } from './mecanicaService';

import estructurarDatos from '../utils/estructurarDatos/informeVehiculoTaller';
// Esctructura de datos para generar PDF del checklist de vehiculo
import { generarPDF as pdf_conductor } from '../utils/pdf/pdfCklVehiculo';
// Esctructura de datos para generar PDF del checklist de mantención de vehiculo
import { generarPDF as pdf_taller } from '../utils/pdf/pdfInformeMantencion';

const url = '/api/vehiculos';
// error.message leera el throw new error.

export const buscarPatentes = async (patente) => {
  try {
    const response = await api.get(
      url+`/buscar/${patente}`,
      { withCredentials: true }
    );

    return response.data.vehiculos || [];

  } catch (error) {
    throw new Error(error.response?.data.msg || error);
  }
};

export const obtenerVehiculoByPatente = async (patente) => {
  try {
    const response = await api.get(
      url+`/ver/vehiculo/patente/${patente}`,
      { withCredentials: true }
    );

    return response.data.vehiculo || [];

  } catch (error) {
    throw new Error(error.response?.data.msg || error);
  }
};

export const obtenerVehiculoById = async (id_vehiculo) => {
  try {
    const response = await api.get(url+`/ver/vehiculo/id/${id_vehiculo}`);
    return response.data.vehiculo || [];
  } catch (error) {
    throw new Error(error.response?.data.msg || error);
  }
};

export const obtenerVehiculos = async (data) => {
  try {
    const response = await api.get(url+'/ver/vehiculos/', data, {
      withCredentials: true,
    });

    return response.data.vehiculos || [];
    
  } catch (error) {
    throw new Error(error.response?.data.msg || error);
  }
};

export const obtenerFlota = async (data) => {
  try {
    const response = await api.get(url+'/ver/flota');
    return response.data.vehiculos || [];
  } catch (error) {
    throw new Error(error.response?.data.msg || error);
  }
};

export const deshabilitarVehiculo = async (data) => {
  try {
    const response = await api.post(url+'/deshabilitar', data, {
      withCredentials: true,
    });

    return response.data || [];
    
  } catch (error) {
    throw new Error(error.response?.data.msg || error);
  }
};

export const subirDocumento = async (patente, tipo_documento, formData) => {
  try {
    const response = await api.post(
      `${url}/documentacion/cargar-archivo`,
      formData,
      { 
        params: { 
          patente: patente, 
          tipo_documento: tipo_documento 
        }, 
        withCredentials: true 
      }
    );

    return response.data || [];
    
  } catch (error) {
    throw new Error(error.response?.data.msg || error);
  }
}

export const eliminarDocumento = async (id_documento) => {
  try {
    const response = await api.post(
      `${url}/documentacion/eliminar-archivo/${id_documento}`,
      { withCredentials: true }
    );

    return response.data || [];
    
  } catch (error) {
    throw new Error(error.response?.data.msg || error);
  }
}

export const  actualizarDocumento = async ( patente, tipo_documento, formData, onProgress ) => {
  try {
    const response = await api.post(
      `${url}/documentacion/actualizar-archivo`,
      formData,
      { 
        params: { 
          patente: patente, 
          tipo_documento: tipo_documento 
        }, 
        
        withCredentials: true,
        
        onUploadProgress: (progressEvent) => {
          const percent = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );

          if (onProgress) onProgress(percent);
        }
      }
    );

    return response.data || [];
    
  } catch (error) {
    throw new Error(error.response?.data.msg || error);
  }
}

export const obtenerDocumentos = async (id_vehiculo) => {
  try {
    const response = await api.get(
      `${url}/documentacion/obtener-archivos/${id_vehiculo}`, 
      { withCredentials: true }
    );

    return response.data.data || [];
    
  } catch (error) {
    throw new Error(error.response?.data.msg || error);
  }
}

export const descargarDocumento = async (id_documento) => {
  try {
    const response = await api.get(
      `${url}/documentacion/descargar-archivo/${id_documento}`, 
      { 
        responseType: 'blob',
        withCredentials: true
      }
    );

    return response;
    
  } catch (error) {
    throw new Error(
      error.response?.data?.msg || 'Error al descargar el archivo'
    );
  }
}

export const obtenerBitacora = async (patente) => {
  try {
    const response = await api.get(
      `${url}/ver/bitacora/${patente}`, 
      { withCredentials: true }
    );

    return response.data.registros || [];
    
  } catch (error) {
    throw new Error(error.response?.data.msg || error);
  }
}

export const generarDocumentoBitacora = async (tipo, id) => {
  if (tipo === 'taller') {

    // Obtener datos
    const data = await obtenerRevision(id);

    // Crear PDF
    const dataEstructurada = estructurarDatos(data);
    const pdf = pdf_taller(dataEstructurada);

    return pdf;
  }

  if (tipo === 'conductor') {

    // Obtener datos
    const data = await obtenerCklVehiculo(id);

    // Crear PDF
    const pdf = pdf_conductor(data);

    return pdf;
  }

  throw new Error('Tipo de documento no soportado');
}